import { useNavigate } from 'react-router-dom';

import { Button } from '@components/button';
import { IconOnboarding } from '@components/icons/onboarding';
import { Text } from '@components/text';

import { Modal, ModalProps, useModal } from 'features/modals';
import { applicationOnboardingUrl } from 'features/routing';
import { useStore } from 'models/Provider';

type Props = ModalProps<{
  applicationId: number;
  jobId: number;
}>;

export const OnboardApplicantModal = (props: Props) => {
  const { applicationId, jobId, closeModal } = props;
  const navigate = useNavigate();
  const { t } = useStore();
  const { setModalAfterClose } = useModal();
  function onSubmit() {
    // Proceeding to onboarding is an explicit choice made from this modal —
    // any pending journey prompt registered against it must not fire once
    // this navigation happens, since it would chase the recruiter onto the
    // onboarding page instead of standing down.
    setModalAfterClose('ONBOARD_APPLICANT', null);
    closeModal();
    navigate(applicationOnboardingUrl(applicationId, jobId));
  }

  return (
    <Modal>
      <Modal.Header text={t('application.onboardmodal.title')} />
      <Text text={t('application.onboardmodal.text')} />
      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={closeModal}
          text={t('application.onboardmodal.button.later')}
        />
        <Button
          onClick={onSubmit}
          iconLeft={<IconOnboarding />}
          text={t('application.onboardmodal.button.go')}
        />
      </Modal.Actions>
    </Modal>
  );
};
